var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-charts"},[_c('div',{staticStyle:{"width":"200px","margin":"0 auto","height":"50px"},attrs:{"id":"lineChart"}})])}]

export { render, staticRenderFns }